import { useContext } from 'react';

import { BlockContext } from './blockContext';

const useBlockContext = () => useContext(BlockContext);

export default useBlockContext;
